module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGac346a9eb533a031e4f7c0edbf3072af.ac346a9e.png";